/**
 * Cart
 */

export const cart = {
    namespaced: true,
    state: () => ({
        items: [],
        // groups: {},
        total: 0,
        total_old: 0,
        total_formatted: '',
        total_old_formatted: '',
        oldAmount: 0,
        hasUnavailable: null,
        addedToast: false,
    }),
    mutations: {
        setCart: (state, payload) => {
            state.items = [...payload.data.items];
            state.total = parseFloat(payload.data.total);
            state.total_old = parseFloat(payload.data.total_old);
            state.total_formatted = payload.data.total_formatted;
            state.total_old_formatted = payload.data.total_old_formatted;
            // state.groups = { ...payload.groups };
            // state.groups = { ...payload.groups };
            // state.amount = parseFloat(payload.amount);
            // state.oldAmount = parseFloat(payload.oldAmount);
            // state.hasUnavailable = payload.hasUnavailable;
        },

        setQty: (state, payload) => {
            state.items = state.items.map((item, index) => {
                let set = payload.set_id ? payload.set_id : 0
                if (item.id == payload.id && item.set_id == set) {
                    item.qty = payload.qty;
                }

                return item;
            });
        },

        setAddedToast: (state, payload) => {
            state.addedToast = payload;
        }
    },
    actions: {
        getCart: ({commit}, payload) => {
            let params = {};

            // Если выбран плательщик, добавляем параметр в запрос
            if (typeof payload !== 'undefined' && typeof payload.payer !== 'undefined') {
                params.payer = payload.payer
            }

            axios.get('/ajax/cart', {params: params})
                .then(request => {
                    commit('setCart', {
                        ...request.data,
                        // amount: parseFloat(request.data.amount),
                        // oldAmount: parseFloat(request.data.old_amount),
                        // hasUnavailable: request.data.has_unavailable
                    });
                });
        },

        addToCart: ({commit, dispatch}, payload) => {
            let params = {
                id: payload.id,
                // qty: payload.qty,
            };

            axios.post('/ajax/cart/add', params)
                .then(request => {
                    commit('setAddedToast', true);
                    setTimeout(() =>  commit('setAddedToast', false), 3000);
                    dispatch('getCart');

                    let products = [];

                    for (let i = 0; i < request.data.items.length; i++) {
                        products[i] =  {
                            "id": request.data.items[i].sku,
                            "name": request.data.items[i].title,
                            "price": request.data.items[i].price,
                            "category": request.data.items[i].category_name,
                            "quantity": request.data.items[i].qty
                        };
                    }

                    // metrika
                    ym(99559018,'reachGoal','ADDTOCART')

                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",
                            "add": {
                                "products": products
                            }
                        }
                    });
                });
        },

        deleteFromCart: ({commit, dispatch}, payload) => {
            axios.delete('/ajax/cart/delete/' + payload)
                .then(request => {
                    dispatch('getCart');

                    let products = [];

                    for (let i = 0; i < request.data.items.length; i++) {
                        products[i] =  {
                            "id": request.data.items[i].sku,
                            "name": request.data.items[i].title,
                            "price": request.data.items[i].price,
                            "category": request.data.items[i].category_name,
                            "quantity": request.data.items[i].qty
                        };
                    }

                    // metrika
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",
                            "remove": {
                                "products": products
                            }
                        }
                    });
                });
        },

        plus: ({commit, dispatch}, payload) => {
            axios.put('/ajax/cart/plus', payload)
                .then(request => {
                    commit('setQty', {id: payload.id, set_id: payload.set_id, qty: request.data.totalQty});
                    dispatch('getCart');

                    let products =  [{
                        "id": request.data.sku,
                        "name": request.data.title,
                        "price": request.data.price,
                        "category": request.data.category_name,
                        "quantity": request.data.qty
                    }];

                    // metrika
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",
                            "add": {
                                "products": products
                            }
                        }
                    });
                });
        },

        minus: ({commit, dispatch}, payload) => {
            axios.put('/ajax/cart/minus', payload)
                .then(request => {
                    commit('setQty', {id: payload.id, set_id: payload.set_id, qty: request.data.totalQty});
                    dispatch('getCart');

                    let products =  [{
                        "id": request.data.sku,
                        "name": request.data.title,
                        "price": request.data.price,
                        "category": request.data.category_name,
                        "quantity": request.data.qty
                    }];

                    // metrika
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",
                            "remove": {
                                "products": products
                            }
                        }
                    });
                });
        },

        qty: ({commit, dispatch}, payload) => {
            let params = {
                id: payload.id,
                qty: payload.qty,
            };

            axios.put('/ajax/cart/qty', params)
                .then(request => {
                    commit('setQty', {id: payload.id, set_id: payload.set_id, qty: request.data.qty});
                    dispatch('getCart');
                });
        },

        addOrder: ({dispatch}, payload) => {
            let params = {
                delivery_method_id: payload.delivery_method_id,
                // qty: payload.qty,
            };

            axios.post('/ajax/orders/add', params)
                .then(request => {
                    let products = [];

                    for (let i = 0; i < request.data.items.length; i++) {
                        products.push({
                            "id": request.data.items[i]['sku'],
                            "name": request.data.items[i]['title'],
                            "price": request.data.items[i]['price'],
                            "quantity": request.data.items[i]['qty'],
                            "category": request.data.items[i]['category'],
                            // "variant": "",
                        })
                    }

                    // Metrika
                    ym(99559018, 'reachGoal', 'OFORMLENIE');

                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",
                            "purchase": {
                                "actionField": {
                                    "id": request.data.id
                                },
                                "products": products
                            }
                        }
                    });

                    ym(99559018, 'userParams', {
                        ...request.data.utm,
                        UserID: request.data.user_id,
                        amount: request.data.amount
                    });

                    if (request.data.success) {
                        location.href = '/orders/' + request.data.id;
                    }
                });
        },
    },
    getters: {
        amount: state => {
            return state.amount;
        },
        oldAmount: state => {
            return state.oldAmount;
        },
        discount(state) {
            let discount = state.oldAmount - state.amount;

            return discount;
        },
        qty(state) {
            return state.items.length;
        },
    },
}
